export default __webpack_public_path__ + "static/media/rc2.1659656f.jpg";